import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { FaRegFileAlt, FaArrowRight } from "react-icons/fa";
import Navbar from "./Navbar";
import Footer from "./footer";
import "./HomeLayout.css";
import "./ResourcePages.css";

const PolicyPage = ({ title, description, children }) => {
  useEffect(() => {
    const script = document.createElement("script");
    const encodedUrl = encodeURIComponent(window.location.href);
    script.src = `https://billpunch.com/SeoBix/seo_injection.php?webid=9d59d8c77c932613971c6c6c6af12ce8&url=${encodedUrl}&baseUrl=https%3A%2F%2Fbillpunch.com`;
    script.async = true;
    document.body.appendChild(script);
    return () => script.remove();
  }, []);
  const headings = React.Children.toArray(children).filter(child => React.isValidElement(child) && child.type === "h5");
  let sectionIndex = 0;
  const content = React.Children.map(children, child => {
    if (React.isValidElement(child) && child.type === "h5") {
      return <h2 id={`policy-section-${sectionIndex++}`}>{child.props.children}</h2>;
    }
    return child;
  });
  return (
    <div className="billpunch-home resource-page">
      <Helmet><title>{title} | BillPunch</title><meta name="description" content={description} /></Helmet>
      <Navbar />
      <main>
        <header className="resource-hero"><div className="resource-container"><span className="resource-eyebrow"><FaRegFileAlt aria-hidden="true" />BillPunch Policies</span><h1>{title}</h1><p>{description}</p></div></header>
        <div className="resource-container policy-layout">
          <aside className="policy-sidebar"><nav aria-label={`${title} sections`}><h2>On this page</h2><ol>{headings.map((heading, index) => <li key={index}><a href={`#policy-section-${index}`}>{heading.props.children}</a></li>)}</ol></nav><div className="resource-help"><h2>Need clarification?</h2><p>Our team can help with questions about this policy.</p><Link to="/contact_us">Contact Us <FaArrowRight aria-hidden="true" /></Link></div></aside>
          <article className="policy-document" aria-label={title}>{content}</article>
        </div>
      </main>
      <Footer />
    </div>
  );
};
export default PolicyPage;
